import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { getNetworthsaga } from './saga';
import { getNetworthState } from './types';

export const initialState: getNetworthState = {
  isLoading: false,
  isLoadingPerformance: false,
  getNetworthSuccessResponse: null,
  getNetworthFailureResponse: null,
  getNetworthProgressSuccess: null,
  getNetworthProgressFailure: null,
};

const slice = createSlice({
  name: 'getNetworth',
  initialState,
  reducers: {
    getNetworth(state, action: PayloadAction<{ isGroup: boolean }>) {
      state.isLoading = true;
      state.getNetworthFailureResponse = null; // Reset on new submission
    },
    getNetworthSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.getNetworthSuccessResponse = action.payload;
    },
    getNetworthFailure(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.getNetworthFailureResponse = action.payload;
    },
    networthGrowth(state, action: PayloadAction<any>) {
      state.isLoadingPerformance = true;
    },
    networthGrowthSuccess(state, action: PayloadAction<any>) {
      state.isLoadingPerformance = false;
      state.getNetworthProgressSuccess = action.payload;
    },
    networthGrowthFailure(state, action: PayloadAction<any>) {
      state.isLoadingPerformance = false;
      state.getNetworthProgressFailure = action.payload;
    },
    networthGrowthReset(state) {
      state.isLoadingPerformance = false;
      state.getNetworthProgressSuccess = null;
      state.getNetworthProgressFailure = null;
    },
  },
});

export const { actions: goalActions } = slice;

export const useGetNetworthSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: getNetworthsaga });

  return { actions: slice.actions };
};
